// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__OoWW3","detailsBorder":"styles_detailsBorder__2atE8"};